import { motion } from "framer-motion";
import { styled } from "@mui/material";
export const ProjectOverviewContainer = styled(motion.div)(({ theme }) => ({
  width: "90%",
  height: "90%",
  backgroundColor: "rgba(255, 255, 255, 0.3)",
  backdropFilter: "blur(30px)",
  borderRadius: 10,
  padding: "5px",
  //   transition: "all 0.3s ease-in-out",
  //   "&:hover": {
  //     transform: "scale(1.03)",
  //   },
  cursor: "pointer",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    height: 200,
    margin: "10px 0",
  },
}));

export const ProjectImageContainer = styled(motion.div)(({ url,disabled }) => ({
  width: "100%",
  height: "100%",
  backgroundImage: `url('${url}')`,
  backgroundPosition: "center",
  backgroundSize: "cover",
  borderRadius: 10,
  display: "grid",
  placeItems: "center",
  padding: "10px",
  "&:hover": {
    backgroundImage: `linear-gradient(90deg, rgba(0,0,0,0.5026961468181023) 0%, rgba(0,0,0,0.499895026369923) 100%),url('${url}')`,
  },
  filter:disabled?'brightness(0.5)':''
}));

export const ProjectDataContainer = styled("div")(() => ({
  width: "100%",
  height: "100%",
  "& .project-name": {
    fontSize: "2em",
    color: "#fff",
    fontWeight: 600,
  },
  "& .project-description": {
    color: "#fff",
  },
}));

export const ProjectCardExpanded = styled(motion.div)(({ theme }) => ({
  position: "absolute",
  width: "40vw",
  // height: "75vh",
  height: "fit-content",

  backgroundColor: "rgba(255, 255, 255, 0.3)",
  backdropFilter: "blur(20px)",
  borderRadius: 10,
  zIndex: 99999,
  padding: "10px",
  //   top: "35vh",
  top: 0,
  left: "30vw",

  "& .close-icon": {
    position: "absolute",
    top: 10,
    right: 10,
    zIndex: 9999,
    cursor: "pointer",
  },
  [theme.breakpoints.down("lg")]: {
    width: "50vw",
    left:'25vw',
  },
  [theme.breakpoints.down("md")]: {
    width: "60vw",
    left:'20vw'
  },
  [theme.breakpoints.down("sm")]: {
    width: "80vw",
    left:'0vw'
  },

  //   transform: "translate(-50%, -50%)",
}));

export const ProjectExpandedImage = styled("div")(({ url }) => ({
  width: "100%",
  height: "270px",
  backgroundImage: `url('${url}')`,
  backgroundPosition: "center",
  backgroundSize: "cover",
  borderRadius: 10,
}));

export const ProejctExpandedData = styled("div")(() => ({
  marginTop: 20,
  color: "#fff",

  "& .project-tech": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: "10px",
  },
  "& .project-name": {
    color: "#fff",
  },
  "& .project-links": {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: "20px",
    justifyContent: "space-between",
  },
}));

export const ProjectTechContainer = styled("div")(() => ({
  width: "fit-content",
  height: "fit-content",
  // backgroundColor:'#ffffff83',
  margin: "0 15px 0 0 ",
  fontWeight: 700,
  fontSize: "1.1em",

  padding: "5px 10px 5px 0",
  borderRadius: 30,
}));

export const ProjectLink = styled("a")(() => ({
  width: "48%",
  backgroundColor: "#ffffff97",
  height: "100%",
  padding: "5px 10px",
  borderRadius: "5px",
  textDecoration: "none",
  fontWeight: 600,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  color: "#000",
  "& svg": {
    marginRight: "10px",
  },
}));
